function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* eslint-disable max-len */
/* eslint-disable dot-notation */
import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { AgroHeaderContext } from '../../contexts/AgroHeaderContext/AgroHeaderContext';
import PropTypes from 'prop-types';
import withCssProps from '../../hocs/withCssProps';
import { ScrollBarContainer } from '../../atoms/ScrollBarContainer/ScrollBarContainer';
import { Text } from '../../atoms/Text';
import { Box } from '../../atoms/Box';
import { Icard, Icart, IchatLeft, IchatRight, Ilist, Imoney, Itruck2, IavatarUser2, IarrowRight2, Inotify } from '../../atoms/AgroIcon/icons';
import { AgroSpinner } from '../../atoms/AgroSpinner';
var notifData = {
  ReceivedUnread: {
    icon: IchatLeft,
    href: '/myaccount/#/received/'
  },
  Sent: {
    icon: IchatRight,
    href: '/myaccount/#/sent/'
  },
  showOnTop: {
    icon: Inotify
  },
  showOnBottom: {
    icon: Inotify
  },
  SELLER_PENDINGRESPONSE: {
    icon: Icart,
    href: '/myaccount/#/sales?status=SELLER_PENDINGRESPONSE'
  },
  SELLER_PENDINGPAYMENT: {
    icon: Imoney,
    href: '/myaccount/#/sales?status=SELLER_PENDINGPAYMENT'
  },
  SELLER_PENDINGDELIVERY: {
    icon: Itruck2,
    href: '/myaccount/#/sales?status=SELLER_PENDINGDELIVERY'
  },
  BUYER_PENDINGACCEPTANCE: {
    icon: Ilist,
    href: '/myaccount/#/purchases?status=BUYER_PENDINGACCEPTANCE'
  },
  BUYER_PENDINGPAYMENT: {
    icon: Icard,
    href: '/myaccount/#/purchases?status=BUYER_PENDINGPAYMENT'
  },
  BUYER_PENDINGDELIVERY: {
    icon: Itruck2,
    href: '/myaccount/#/purchases?status=BUYER_PENDINGDELIVERY'
  }
};
var UserNotificationsNews = withCssProps(function (_ref) {
  var data = _ref.data,
    loadingNotifications = _ref.loadingNotifications,
    tagManager = _ref.tagManager;
  var _useContext = useContext(AgroHeaderContext),
    baseUrl = _useContext.baseUrl,
    marketUrl = _useContext.marketUrl,
    translations = _useContext.translations,
    logoutFunction = _useContext.logoutFunction;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    notifications = _useState2[0],
    setNotifications = _useState2[1];
  data && Object.keys(data).map(function (key) {
    if (Array.isArray(data[key])) {
      data[key].map(function (n, idx) {
        notifications.push(_objectSpread(_objectSpread({}, data[key][idx]), {}, {
          icon: notifData[key].icon
        }));
      });
    } else {
      notifications.push(_objectSpread(_objectSpread({}, data[key]), {}, {
        icon: notifData[key].icon,
        href: notifData[key].href
      }));
    }
  });
  var getIcon = function getIcon(icon) {
    var Icon = icon;
    return /*#__PURE__*/React.createElement(Icon, {
      fill: "gray800",
      width: "24px",
      height: "24px"
    });
  };
  var handleClick = function handleClick(text) {
    if (tagManager) {
      var tagManagerArgs = {
        dataLayer: {
          event: 'trackEvent',
          eventCategory: 'My account',
          eventAction: text
        }
      };
      tagManager(tagManagerArgs);
    }
  };
  var showTranslation = function showTranslation(translation) {
    return translations[translation];
  };
  var redirect = function redirect(marketUrl, href, id) {
    if (id || id === 0) {
      var requestOptions = {
        method: 'PATCH',
        headers: {
          'Content-Type': 'Multipart/form-data'
        }
      };
      fetch("".concat(marketUrl, "/account/api/notifications/").concat(id), requestOptions);
      if (window && window.location) {
        window.location.href = href;
      }
    } else {
      if (window && window.location) {
        window.location.href = "".concat(marketUrl).concat(href);
      }
    }
  };
  return /*#__PURE__*/React.createElement(Notifications, {
    id: "user-notifications"
  }, /*#__PURE__*/React.createElement(Header, null, /*#__PURE__*/React.createElement(Text, {
    type: "subtitle-lg",
    color: "black",
    pl: "sm"
  }, showTranslation('notifTitle')), /*#__PURE__*/React.createElement(Box, {
    display: "flex"
  }, /*#__PURE__*/React.createElement(AccountBtn, {
    onMouseDown: function onMouseDown() {
      return handleClick('Click - My account');
    },
    href: "".concat(marketUrl, "/myaccount/#/dashboard")
  }, /*#__PURE__*/React.createElement(IavatarUserIcon, {
    width: "16px",
    height: "16px",
    fill: "blue600",
    ml: "xs"
  }), /*#__PURE__*/React.createElement(Text, {
    color: "blue600",
    type: "label-sm",
    pr: "xxs"
  }, showTranslation('account'))), /*#__PURE__*/React.createElement(Btn, {
    onMouseDown: function onMouseDown() {
      return handleClick('Logout');
    },
    href: "#",
    onClick: function onClick() {
      return logoutFunction();
    }
  }, /*#__PURE__*/React.createElement(Text, {
    color: "blue600",
    type: "label-sm",
    pr: "sm",
    pl: "xxs"
  }, showTranslation('logout'))))), /*#__PURE__*/React.createElement(Body, null, loadingNotifications ? /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    "justify-content": "center",
    my: "md"
  }, /*#__PURE__*/React.createElement(AgroSpinner, {
    size: "24px",
    variant: "gray"
  })) : !(notifications && notifications.length) ? /*#__PURE__*/React.createElement(Text, {
    display: "flex",
    py: "lg",
    "justify-content": "center"
  }, showTranslation('noNotif')) : /*#__PURE__*/React.createElement(Box, {
    mb: "xs"
  }, notifications.filter(function (item) {
    return item.count > 0;
  }).map(function (item, id) {
    return /*#__PURE__*/React.createElement(Notification, {
      key: id
      // href={`${baseUrl}${item.href}`}
      ,
      onClick: function onClick() {
        return redirect(marketUrl, item.href, item.id);
      }
    }, /*#__PURE__*/React.createElement(Icon, {
      display: "flex",
      "justify-content": "center"
    }, getIcon(item.icon)), /*#__PURE__*/React.createElement(Content, {
      display: "flex",
      "flex-direction": "column"
    }, /*#__PURE__*/React.createElement(Text, {
      pb: "xxs",
      type: "label-md",
      color: "gray900",
      dangerouslySetInnerHTML: {
        __html: item.text
      }
    }), /*#__PURE__*/React.createElement(Text, {
      color: "blue600",
      type: "subtitle-sm"
    }, item.linkText)), /*#__PURE__*/React.createElement(Arrow, {
      display: "flex",
      "justify-content": "center",
      "align-items": "center"
    }, /*#__PURE__*/React.createElement(IarrowRight2, {
      fill: "gray600"
    })));
  }))));
});
UserNotificationsNews.propTypes = {
  data: PropTypes.object,
  loadingNotifications: PropTypes.bool
};
UserNotificationsNews.displayName = 'UserNotificationsNews';
export { UserNotificationsNews };
var Notifications = styled.div.withConfig({
  displayName: "UserNotificationsNews__Notifications",
  componentId: "fdsagp-0"
})(["background:#ffffff;box-shadow:0px 6px 10px rgba(0,0,0,0.15);border-radius:12px;position:absolute;z-index:200;top:40px;padding:0;color:#999;font-size:12px;right:0px;width:374px;font-family:", ";:after{content:'';position:absolute;display:block;right:40px;top:-8px;z-index:99999999;width:0;height:0;border-left:10px solid transparent;border-right:10px solid transparent;border-bottom:10px solid ", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.fontFamily;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.gray100;
});
var Body = styled(ScrollBarContainer).withConfig({
  displayName: "UserNotificationsNews__Body",
  componentId: "fdsagp-1"
})(["overflow-y:auto;max-height:442px;min-height:40px;display:block;::-webkit-scrollbar{width:6px;}::-webkit-scrollbar-track{background:", ";}::-webkit-scrollbar-thumb{width:2px;background:", ";border-radius:15px;}::-webkit-scrollbar-thumb:hover{background:", ";}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.white;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.gray300;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.gray300;
});
var Header = styled.div.withConfig({
  displayName: "UserNotificationsNews__Header",
  componentId: "fdsagp-2"
})(["background:", ";border-radius:12px 12px 0px 0px;line-height:35px;height:40px;display:flex;justify-content:space-between;align-items:center;"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.gray100;
});
var IavatarUserIcon = styled(IavatarUser2).withConfig({
  displayName: "UserNotificationsNews__IavatarUserIcon",
  componentId: "fdsagp-3"
})(["margin-right:5px;"]);
var Btn = styled.a.withConfig({
  displayName: "UserNotificationsNews__Btn",
  componentId: "fdsagp-4"
})(["text-decoration:none;display:flex;align-items:center;height:40px;&:hover{background:rgba(0,80,138,0.05);}:last-child{border-top-right-radius:12px;}"]);
var AccountBtn = styled(Btn).withConfig({
  displayName: "UserNotificationsNews__AccountBtn",
  componentId: "fdsagp-5"
})(["&:after{content:'';height:16px;border-right:1px solid ", ";}"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.gray500;
});
var Notification = styled.a.withConfig({
  displayName: "UserNotificationsNews__Notification",
  componentId: "fdsagp-6"
})(["text-decoration:none;cursor:pointer;border-bottom:2px solid ", ";display:flex;padding:20px 0px 20px 0px;:last-child{border-bottom:none;}"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.gray200;
});
var Icon = styled(Box).withConfig({
  displayName: "UserNotificationsNews__Icon",
  componentId: "fdsagp-7"
})(["margin:0px 12px 0px 24px;min-width:24px;"]);
var Arrow = styled(Box).withConfig({
  displayName: "UserNotificationsNews__Arrow",
  componentId: "fdsagp-8"
})(["margin:0px 14px 0px 2px;min-width:24px;"]);
var Content = styled(Box).withConfig({
  displayName: "UserNotificationsNews__Content",
  componentId: "fdsagp-9"
})(["flex-grow:1;"]);